export const JOIN_US = {
  pt: {
    t1: "De que está à espera?",
    t2: "Junte-se aos mais de 40 mil profissionais que confiam em nós",
    action: "Experimentar plataforma",
  },
  en: {
    t1: "What are you waiting for?",
    t2: "Join 40k+ business professionals who use our platform",
    action: "Sign up",
  },
  es: {
    t1: "¿A qué está esperando?",
    t2: "Únase a 40k+ personas que ya confían en nosotros",
    action: "Pruebe nuestra aplicación",
  },
};
